// Google Analytics utility functions for tracking custom events

/**
 * Track a custom event
 * @param {string} eventName - The name of the event
 * @param {object} parameters - Additional parameters for the event
 */
export function trackEvent(eventName, parameters = {}) {
  if (window.gtag) {
    window.gtag('event', eventName, parameters)
  }
}

/**
 * Track page view for SPA navigation
 * @param {string} pagePath - The path of the page
 * @param {string} pageTitle - The title of the page
 */
export function trackPageView(pagePath, pageTitle) {
  if (window.gtag) {
    window.gtag('config', 'G-22DJ2JWMGG', {
      page_path: pagePath,
      page_title: pageTitle
    })
  }
}

/**
 * Track button click events
 * @param {string} buttonName - Name/identifier of the button
 * @param {string} location - Where the button is located
 */
export function trackButtonClick(buttonName, location = 'unknown') {
  trackEvent('button_click', {
    button_name: buttonName,
    location: location
  })
}

/**
 * Track map interactions
 * @param {string} interactionType - Type of interaction (zoom, pan, click, etc.)
 * @param {object} additionalData - Additional data about the interaction
 */
export function trackMapInteraction(interactionType, additionalData = {}) {
  trackEvent('map_interaction', {
    interaction_type: interactionType,
    ...additionalData
  })
}

/**
 * Track chart interactions
 * @param {string} chartType - Type of chart (bar, pie, etc.)
 * @param {string} interactionType - Type of interaction (hover, click, etc.)
 * @param {object} additionalData - Additional data about the interaction
 */
export function trackChartInteraction(chartType, interactionType, additionalData = {}) {
  trackEvent('chart_interaction', {
    chart_type: chartType,
    interaction_type: interactionType,
    ...additionalData
  })
}

/**
 * Track filter usage
 * @param {string} filterType - Type of filter used
 * @param {string} filterValue - Value selected in filter
 */
export function trackFilterUsage(filterType, filterValue) {
  trackEvent('filter_used', {
    filter_type: filterType,
    filter_value: filterValue
  })
}

/**
 * Track data download
 * @param {string} dataType - Type of data downloaded
 * @param {string} format - Format of downloaded data
 */
export function trackDataDownload(dataType, format = 'unknown') {
  trackEvent('data_download', {
    data_type: dataType,
    format: format
  })
} 